<script>
import { mapGetters, mapMutations } from 'vuex';
import ProductListItem from './ComparedProductListItemBar.vue';

export default {
  name: 'ComparedProductListBar',
  components: { ProductListItem },
  computed: {
    ...mapGetters({
      comparedProducts: 'compare/products',
    }),
    productIdsQuery() {
      return this.comparedProducts.map((product) => product.id).join(',');
    },
    canCompare() {
      return (this.comparedProducts || []).length > 1;
    },
  },
  methods: {
    ...mapMutations({
      deleteAllProducts: 'compare/DELETE_ALL_PRODUCTS',
    }),
  },
};
</script>

<template>
  <div
    v-if="comparedProducts.length"
    class="fixed hidden md:block w-full bg-gray-200 bg-opacity-90 left-0
    bottom-0 text-base z-10 px-8 py-4 z-20"
  >
    <h3 class="text-lg leading-6 font-medium text-gray-900">
      {{ $tc('comparedProductListBar.title', comparedProducts.length) }}
    </h3>

    <dl class="mt-5 grid grid-cols-1 gap-5 sm:grid-cols-3">
      <ProductListItem
        v-for="(product, index) in comparedProducts"
        :key="product.id"
        :productNumber="index+1"
        :product="product"
      />
    </dl>

    <p class="text-center mt-4" v-if="canCompare">
      <router-link
        :to="{ name: `compare${uppercaseLocale}`, query: { productIds: productIdsQuery } }"
        class="inline-flex items-center px-4 py-2 border border-transparent text-base font-medium
        rounded-md text-white bg-orange-diagomics-light hover:bg-orange-diagomics-dark
        focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500">
          <span>{{ $t('compare') }}</span>
          <i class="fas fa-arrow-right ml-2"></i>
      </router-link>
    </p>

    <div class="absolute top-0 right-0">
      <button
        type="button"
        @click="deleteAllProducts"
        class="mt-4 mr-4 rounded-md inline-flex text-gray-400 hover:text-gray-500
              focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
      >
        <i class="fas fa-times text-lg"></i>
      </button>
    </div>
  </div>
</template>
